import styled from 'styled-components'

import { useEffect } from 'react'

import { homeLink, loginLink, WithLoginCallbackRoute } from 'router'
import { SpinnerIcon } from '../Spinner/Spinner'
import { useOktaAuth } from '@okta/okta-react'

import type { WithLoginStore } from 'stores/RootStoreModel'

interface LoginCallbackProps extends WithLoginStore, WithLoginCallbackRoute {}

const LoginCallbackContainer = styled.div`
  inline-size: 100%;
  block-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const gotoLoginPage = () => loginLink.replace()
const gotoHomepage = () => homeLink.replace()

const GCS_LOGIN_SUCCEEDED_FLAG = 'GCS_LOGIN_SUCCEEDED'

export const LoginCallback = ({ currentRoute, loginStore }: LoginCallbackProps) => {
  const { oktaAuth } = useOktaAuth()

  useEffect(() => {
    void (async () => {
      const authorizationCode = currentRoute.params.code
      if (authorizationCode === undefined) {
        // TODO: Maybe display error on screen and put it in loginStore
        console.error('No authorization code present in okta response')
        gotoLoginPage()
        return
      }

      const isAfterGcsLogin = localStorage.getItem(GCS_LOGIN_SUCCEEDED_FLAG) === 'true'

      if (!isAfterGcsLogin) {
        // log into GCS, if succeeded go to okta again for new okta code for oversight login
        if (loginStore.loginStatus.inProgress) {
          console.warn('Double invocation of login callback useEffect GCS')
          return
        }
        await loginStore.loginToGcsWithAuthorizationCode(authorizationCode)
        if (loginStore.loginStatus.isSuccess){
          localStorage.setItem(GCS_LOGIN_SUCCEEDED_FLAG, 'true') 
          await oktaAuth.signInWithRedirect()
        } else {
          localStorage.removeItem(GCS_LOGIN_SUCCEEDED_FLAG) 
          gotoLoginPage()
        }
      } else {
        if (loginStore.oversightLoginStatus.inProgress) {
          console.warn('Double invocation of login callback useEffect Oversight')  
          return
        }
        await loginStore.loginToOversightWithAuthorizationCode(authorizationCode)
        localStorage.removeItem(GCS_LOGIN_SUCCEEDED_FLAG) 
        if (loginStore.oversightLoginStatus.isSuccess) {
          // Since center app might be used on shared device,
          // we wish to stay signed in to Okta for the shortest time possible.
          await oktaAuth.signOut()

          gotoHomepage()
        } else {
          localStorage.removeItem(GCS_LOGIN_SUCCEEDED_FLAG)  // If oversight login failed, we prefer staring the whole login again, including GCS login
          gotoLoginPage() 
        }
      }
    })()
  }, [])
  return (
    <LoginCallbackContainer>
      <div>
        <span>Signing in...</span>
        <SpinnerIcon title="Signing in..." style={{ margin: '1em' }} />
      </div>
    </LoginCallbackContainer>
  )
}
